import { CommonModule } from '@angular/common';
import { MatSliderModule } from '@angular/material/slider';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularMaterialModule } from '../module/angular-material.module';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { DropdownSearchableRenderedComponent } from './dropdown-searchable-rendered.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    AngularMaterialModule,
    ReactiveFormsModule,
    FormsModule,
    MatSliderModule,
    MatFormFieldModule,
    MatInputModule,
    TranslateModule,
  ],
  declarations: [DropdownSearchableRenderedComponent],
  exports: [DropdownSearchableRenderedComponent],
  providers: [],
})
export class DropdownSearchableRenderedModule { }
